import { Divider, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { CartProductCode, FlowType } from '@ace-clublabs/common-membership-api-types';
import { ReviewItem } from './ReviewItem';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import { getMembershipTitle } from '../../utils/helpers';
import { ProductType } from '../../application/models/NewJoinSessionData';

export const ReviewBenefitLevelSection = () => {
  const { sessionData } = useContext(MembershipAppStateContext);
  const serviceLevelCost = sessionData?.priceCart?.items?.find((item) => item.code === CartProductCode.SERVICELEVEL);
  const admissionFeeCost = sessionData?.priceCart?.items?.find((item) => item.code === CartProductCode.ADMISSION);

  const hasRV = sessionData.formData?.products?.includes(ProductType.RV);
  const membershipTitle = <>{getMembershipTitle(sessionData.formData.membershipLevel!, hasRV)} member</>;
  const hasMembershipDiscount = typeof serviceLevelCost?.discount === 'number' && serviceLevelCost?.discount > 0;
  const getPromotionTitle = (flowType: FlowType, hasMembershipDiscount?: boolean) => {
    switch (flowType) {
      case FlowType.EMPLOYEE:
        return 'Employee discount';
      case FlowType.T_MOBILE:
        return 'Year on Us by T-Mobile';
      default:
        if (hasMembershipDiscount) {
          return 'Membership discount';
        }
        return '';
    }
  };

  return (
    <Stack>
      <Stack direction="column" className="benefit-level-section" width="100%" gap="0.5rem">
        <Typography variant="b3Regular" className="benefit-section-title">
          Benefit level
        </Typography>
        <ReviewItem
          className="benefit-level"
          title={membershipTitle}
          subtitle={getPromotionTitle(sessionData?.flowType!, hasMembershipDiscount)}
          {...serviceLevelCost!}
        />
        <ReviewItem
          className="primary-member"
          title={`• ${sessionData.formData.firstName} ${sessionData.formData.lastName}`}
          subtitle="primary"
          mask={true}
        />
        <ReviewItem className="admission-fee" title="New member admission fee" {...admissionFeeCost!} />
      </Stack>
      <Divider variant="fullWidth" sx={{ margin: '1rem 0' }} />
    </Stack>
  );
};
